import { render, staticRenderFns } from "./ReportTaxMonitoring.vue?vue&type=template&id=3c065c8e&scoped=true"
import script from "./ReportTaxMonitoring.vue?vue&type=script&lang=js"
export * from "./ReportTaxMonitoring.vue?vue&type=script&lang=js"
import style0 from "./ReportTaxMonitoring.vue?vue&type=style&index=0&id=3c065c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c065c8e",
  null
  
)

export default component.exports